// extracted by mini-css-extract-plugin
export default {"container":"WishlistForm_container__pXrGH"};